import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import { TextBold } from 'UiKit/typography';
import FilterDateRangePicker from 'UiKit/filter-date-range-picker';
import useGetPresences from 'Domain/host-attendance-record/useGetPresences';
import useGetTaskSummary from 'Domain/host-presence-content/useGetTaskSummary';
import OverviewContent from 'View/host-presence-content/components/overview-content';
import ListReportContent from 'View/host-presence-content/components/list-report-content';
import OverviewContentSkeleton from 'View/host-presence-content/components/skeleton/overview-content-skeleton';
import { useHostPresenceContentState } from 'View/host-presence-content/state';

import styles from './styles.module.css';

const ReportContent = () => {
  const { t } = useTranslation('host-content');
  const { filterState, updateFilterState } = useHostPresenceContentState();
  const { data: taskSummary, isLoading: isTaskSummaryLoading } = useGetTaskSummary({ enabled: true });

  const { data: presenceData } = useGetPresences();

  const onChangeDateRange = ({ startDate, endDate }) => {
    updateFilterState({ startDate, endDate, page: 1 });
  };

  return (
    <Box className={styles['report-content__container']}>
      <Condition statement={!isTaskSummaryLoading} fallback={<OverviewContentSkeleton />}>
        <OverviewContent presenceData={presenceData} taskData={taskSummary} />
      </Condition>
      <Box className={styles['report-content__content']}>
        <TextBold>{t('page.report_title')}</TextBold>
        <FilterDateRangePicker
          startDate={filterState?.startDate}
          endDate={filterState?.endDate}
          onChange={onChangeDateRange}
          icon="calendar"
          placement="right"
          variant="outlined"
        />
        <ListReportContent />
      </Box>
    </Box>
  );
};

export default ReportContent;
